import { currentEnv } from './detect-env'

// Paste each env's values below to enable tracking. Envs left blank stay silent
// (local dev is off by default — no need to pollute analytics from dev).
const websiteIds: Record<string, string> = {
  local: '',
  staging: '',
  production: '38edae14-cd97-4644-a4df-b77501184efb',
}

const scriptSrcs: Record<string, string> = {
  local: '', // e.g. 'http://umami.rapa-main.localhost/script.js'
  staging: '',
  production: 'https://uanalytics.tnapp.io/script.js',
}

export function loadUmami(): void {
  const websiteId = websiteIds[currentEnv] ?? ''
  const src = scriptSrcs[currentEnv] ?? ''
  if (!websiteId || !src) return
  if (document.querySelector('script[data-website-id]')) return

  // Umami v2 auto-tracks SPA route changes via the History API, so loading the
  // script is all that's needed — no per-navigation wiring.
  const script = document.createElement('script')
  script.async = true
  script.defer = true
  script.src = src
  script.setAttribute('data-website-id', websiteId)
  document.head.appendChild(script)
  console.log('Umami script loaded:', { websiteId, src })
}
